import { createAction } from 'redux-actions';

export const setContentFixedMode = createAction('SET_STATEMENT_FIXED_MODE');
export const setContentFullMode = createAction('SET_STATEMENT_FULL_MODE');
